export interface ScrollEdges {
  /** За левым краем есть скрытое содержимое. */
  start: boolean
  /** За правым краем есть скрытое содержимое. */
  end: boolean
}

// Дробные размеры при масштабировании дают расхождение в пиксель: без запаса затухание
// остаётся у края, до которого уже докрутили.
const EDGE_TOLERANCE = 1

export function getScrollEdges(
  scrollLeft: number,
  clientWidth: number,
  scrollWidth: number
): ScrollEdges {
  return {
    start: scrollLeft > EDGE_TOLERANCE,
    end: scrollLeft + clientWidth < scrollWidth - EDGE_TOLERANCE,
  }
}

const FADE_WIDTH = '2rem'
const CLEAR = 'transparent'
const SOLID = 'black'

/**
 * Маска полосы: у края, за которым есть скрытое содержимое, содержимое гаснет до прозрачного.
 * Маска, а не оверлей поверх — затухание не зависит от цвета фона под полосой.
 */
export function getFadeMask(edges: ScrollEdges): string | undefined {
  if (!edges.start && !edges.end) return undefined
  const from = edges.start ? CLEAR : SOLID
  const to = edges.end ? CLEAR : SOLID
  return `linear-gradient(to right, ${from} 0, ${SOLID} ${FADE_WIDTH}, ${SOLID} calc(100% - ${FADE_WIDTH}), ${to} 100%)`
}

/**
 * Новый `scrollLeft`, при котором элемент целиком виден в полосе (как `inline: 'nearest'`):
 * уже виден — позиция прежняя. Своя прокрутка полосы, а не `scrollIntoView`, чтобы не
 * сдвигать страницу по вертикали.
 */
export function getScrollLeftToReveal(
  scrollLeft: number,
  clientWidth: number,
  itemLeft: number,
  itemWidth: number
): number {
  if (itemLeft < scrollLeft) return itemLeft
  if (itemLeft + itemWidth > scrollLeft + clientWidth) return itemLeft + itemWidth - clientWidth
  return scrollLeft
}
